/**
 * Base URL of the CLI facade as the insight-impact dialog resolves it.
 *
 * Extracted from `InsightImpactDialog.tsx` (W13 DM2) for ONE reason: the body
 * reads `import.meta.env` at call time, which jest (CJS) cannot parse, so the
 * dialog could not be rendered in a jsdom test at all. The logic is unchanged,
 * byte for byte.
 *
 * Deliberately NOT folded into `services/builderApiClient.getBuilderApiBaseUrl`:
 * that one prefers `VITE_AGENT_API_URL` and falls back to :8080 (edge gateway),
 * while this surface talks to the builder on :8081. Unifying them would move
 * every local impact call to a different port — a behaviour change this task
 * does not own.
 */
export function getInsightImpactApiBaseUrl(): string {
  if (import.meta.env.VITE_BUILDER_API_URL) return import.meta.env.VITE_BUILDER_API_URL;
  if (import.meta.env.VITE_AGENT_API_URL) return import.meta.env.VITE_AGENT_API_URL;
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  if (hostname === 'localhost' || hostname === '127.0.0.1') return 'http://localhost:8081';
  if (hostname === 'dev.segmently.ai' || hostname.includes('devsegmentlyai')) return 'https://dev-api.segmently.ai';
  if (hostname === 'stage.segmently.ai' || hostname.includes('stagesegmentlyai')) return 'https://stage-api.segmently.ai';
  return 'https://api.segmently.ai';
}
